import { z } from "zod";

//
// Read
//

export const DTODocumentationPageDependencies = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  documentationPageId: z.string(),

  tokenPersistentIds: z.array(z.string()),
  figmaComponentPersistentIds: z.array(z.string()),
  componentPersistentIds: z.array(z.string()),
  figmaNodePersistentIds: z.array(z.string()),
  groupPersistentIds: z.array(z.string()),
  propertyPersistentIds: z.array(z.string()),
  themePersistentIds: z.array(z.string()),
  documentationPagePersistentIds: z.array(z.string()),
  storybookEntriesStoryIds: z.array(z.string()),
});

export const DTODocumentationPageDependenciesGetResponse = z.object({
  dependencies: z.array(DTODocumentationPageDependencies),
});

export type DTODocumentationPageDependencies = z.infer<typeof DTODocumentationPageDependencies>;
export type DTODocumentationPageDependenciesGetResponse = z.infer<typeof DTODocumentationPageDependenciesGetResponse>;
